module.exports = __webpack_public_path__ + "media/images/wdwdc-bg-a3c4d6559d69158b4384df3bbb22514b.svg";